/* c8 ignore start */
import { mspRoutes } from "./routes";

import modules from "./store";

import { NAV_ITEMS_MODE } from "@/constants";

import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const SecurityAwarnessTrainingModule = ({
  router,
  store,
  registerNavItems,
}) => {
  // Routes
  router.addRoute(mspRoutes);

  // Stores
  store.registerModule("sat_customers", modules.customers);
  store.registerModule("sat_cards", modules.cards);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { SecurityAwarnessTrainingModule };

export default {};
/* c8 ignore end */
